// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tCtY0","type":"styles_type__zqNKJ","choices":"styles_choices__3hhWK"};